export default __webpack_public_path__ + "static/media/car-engine-1.c855e10a.jpg";